import React, {useEffect, useState} from 'react';
import {Box, Button, Card, CardContent, Grid, List, ListItem, ListItemText, Paper, Typography} from "@deere/fuel-react";
import "../assets/Campaigns.scss";
import {ListItemPrimary} from "../shared/ListItemPrimary";
import {ListItemSecondary} from "../shared/ListItemSecondary";

export const CampaignCriteriaCard = ({currentData, onHandleEdit = () => {}, isPublish = false}) => {
    const criteriaArr = currentData.criteriaSelectedData
    const [qualityStakeholders, setQualityStakeholders] = useState([]);
    const [deliveryStakeholders, setDeliveryStakeholders] = useState([]);
    const [processStakeholders, setProcessStakeholders] = useState([]);
    const [relationStakeholders, setRelationStakeholders] = useState([]);
    const [valueStakeholders, setValueStakeholders] = useState([]);
    const [stakeholderType, setStakeholderType] = useState([]);

    const fetchStakeHolders = (arr) => {
        return arr && arr.map(item => {
            return extractStakeholders(item.stakeholders)
        })
    }
    const extractStakeholders = (arr) => {
        return arr.map(item => {
            return item.description
        })
    }

    useEffect(() => {
        if(criteriaArr.length > 0) {
            const qualityArr = [...new Set(fetchStakeHolders(criteriaArr.filter(item => item.category.id === 1)).flat())]
            const deliveryArr = [...new Set(fetchStakeHolders(criteriaArr.filter(item => item.category.id === 2)).flat())]
            const processArr = [...new Set(fetchStakeHolders(criteriaArr.filter(item => item.category.id === 3)).flat())]
            const relationArr = [...new Set(fetchStakeHolders(criteriaArr.filter(item => item.category.id === 4)).flat())]
            const valueArr = [...new Set(fetchStakeHolders(criteriaArr.filter(item => item.category.id === 5)).flat())]
            setQualityStakeholders(qualityArr)
            setDeliveryStakeholders(deliveryArr)
            setProcessStakeholders(processArr)
            setRelationStakeholders(relationArr)
            setValueStakeholders(valueArr)
            setStakeholderType([...new Set([].concat(...qualityArr, ...deliveryArr, ...processArr, ...relationArr, ...valueArr))])
        }
        return () => {
            setQualityStakeholders([]);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentData]);

    return (
        <Grid item md={6}>
            <Box mt={6} mr={6}>
                <Card>
                    <CardContent>
                        <Box m={2}>
                            <Grid container alignItems="flex-start" spacing={6}>
                                <Grid item md={11}>
                                    <Typography variant="h3" gutterBottom display="inline">
                                        {`${currentData.criteriaSelectedData.length} Criteria`}
                                    </Typography>
                                    <Typography color="tertiary" size="md" component="p" gutterBottom display="inline">
                                        {`  (${stakeholderType.length} Stakeholder type${stakeholderType.length === 1 ? "" : "s"})`}
                                    </Typography>
                                </Grid>
                                <Grid item md={1}>
                                    {!isPublish && (<Button variant="text" onClick={() => onHandleEdit(1)}>Edit</Button>)}
                                </Grid>
                                <Grid item md={12}>
                                    <Paper>
                                        <List disablePadding component="nav" aria-label="criteria card">
                                            {currentData.qualityCriteriaData.length > 0 && (
                                                <ListItem divider>
                                                    <ListItemText primary={
                                                        <ListItemPrimary
                                                            content={`${currentData.qualityCriteriaData.length} - Quality`}/>
                                                    }
                                                                  secondary={
                                                                      <ListItemSecondary
                                                                          content={`${qualityStakeholders.join(', ')}`}/>
                                                                  }/>
                                                </ListItem>
                                            )}
                                            {currentData.deliverCriteriaData.length > 0 && (
                                                <ListItem divider>
                                                    <ListItemText primary={
                                                        <ListItemPrimary
                                                            content={`${currentData.deliverCriteriaData.length} - Delivery`}/>
                                                    }
                                                                  secondary={
                                                                      <ListItemSecondary
                                                                          content={`${deliveryStakeholders.join(', ')}`}/>
                                                                  }/>
                                                </ListItem>
                                            )}
                                            {currentData.processAlignmentCriteriaData.length > 0 && (
                                                <ListItem divider>
                                                    <ListItemText primary={
                                                        <ListItemPrimary
                                                            content={`${currentData.processAlignmentCriteriaData.length} - Process Alignment`}/>
                                                    }
                                                                  secondary={
                                                                      <ListItemSecondary
                                                                          content={`${processStakeholders.join(', ')}`}/>
                                                                  }/>
                                                </ListItem>
                                            )}
                                            {currentData.relationshipCriteriaData.length > 0 && (
                                                <ListItem divider>
                                                    <ListItemText primary={
                                                        <ListItemPrimary
                                                            content={`${currentData.relationshipCriteriaData.length} - Relationship`}/>
                                                    }
                                                                  secondary={
                                                                      <ListItemSecondary
                                                                          content={`${relationStakeholders.join(', ')}`}/>
                                                                  }/>
                                                </ListItem>
                                            )}
                                            {currentData.valueCreationCriteriaData.length > 0 && (
                                                <ListItem divider>
                                                    <ListItemText primary={
                                                        <ListItemPrimary
                                                            content={`${currentData.valueCreationCriteriaData.length} - Value Creation`}/>
                                                    }
                                                                  secondary={
                                                                      <ListItemSecondary
                                                                          content={`${valueStakeholders.join(', ')}`}/>
                                                                  }/>
                                                </ListItem>
                                            )}
                                        </List>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Grid>
    )
}
